import MessageItem from 'components/MessageItem';
import React from 'react';

export function MessagePage() {
  return <MessageItem />;
}
